// Open the header search panel right below whatever sits above the header (announcement bar),
// so nothing covers the field. Once that bar has scrolled away the panel starts at the top.
(() => {
  if (window.kslSearchPanel) return;
  window.kslSearchPanel = true;

  const place = (details) => {
    const panel = details.querySelector('.ksl-search');
    if (!panel) return;
    const header = details.closest('.section-header') || document.querySelector('.section-header');
    const top = Math.max(0, Math.round(header?.getBoundingClientRect().top || 0));
    panel.style.setProperty('--ksl-search-top', `${top}px`);
  };
  const openPanel = () => document.querySelector('details-modal.header__search details[open]');

  // `toggle` does not bubble; listen in the capture phase.
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (details instanceof HTMLDetailsElement && details.open && details.closest('details-modal.header__search')) place(details);
  }, true);
  window.addEventListener('resize', () => { const details = openPanel(); if (details) place(details); }, { passive: true });
})();
